import { HouseSyncIcon } from "@/components/atoms/icons";

type AssignMaterialsInfoProps = {
  greenCenter: string;
  cooperative: string;
};

export function AssignMaterialsInfo({ greenCenter, cooperative }: AssignMaterialsInfoProps) {
  return (
    <div className="border-urbix-gray-300 rounded-md border p-3">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100">
          <HouseSyncIcon size={20} />
        </div>
        <div>
          <div className="text-sm text-urbix-gray-1000">
            Centro Verde: <span className="font-semibold">{greenCenter}</span>
          </div>
          <div className="text-xs text-urbix-gray-700">Cooperativa: {cooperative}</div>
        </div>
      </div>
    </div>
  );
}
